import { G_lastRadios } from "../../../utils/globals/globals";
import check from "./check";
import uncheck from "./uncheck";

/**
 * Run trigger on check or uncheck the radio
 * @param {MainClassProps} main
 * @param {HTMLInputElement} target
 * @param {TriggerProps} trigger
 */
const changeRadio = (main, target, trigger) => {
  if (target?.checked) {
    check(trigger, main);

    G_lastRadios.set(target, [trigger, main]);
  }

  const name = target.name;
  const radios = /** @type {Array<HTMLInputElement>} */ ([
    ...document.querySelectorAll(`input[type='radio'][name='${name}']`),
  ]);

  for (const radio of radios) {
    if (!radio.checked) {
      const last = G_lastRadios.get(radio);

      if (last) {
        uncheck(last[0], last[1]);
        G_lastRadios.delete(radio);
      }
    }
  }
};

export default changeRadio;
